import Joi from 'joi';

/**
 * Schema for renewed outbox record validation.
 */
export const renewOutboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
